/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_B_Notes_HeaderInputs */



/**
* | output |
* | --- |
* | "Group B Notes" |
*
* @param {Compare_Event_Groups_Csv_Group_B_Notes_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_b_notes_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_B_Notes_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_B_Notes_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes du groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe B Notizen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note del Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания группы B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apuntes del Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("B组笔记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBに関するメモ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बी नोट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas do Grupo B")
	return /** @type {LocalizedString} */ ("Group B Notes")
});